module.exports = __webpack_public_path__ + "media/images/custom_page/tempest/make-video_1-f7ce11cd73d972c0d5bfa3d0564299c0.png";